/**
 * 知识库 文件列表
 */

import { observer } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import { ALL_FILE_ICONS } from '../input-file/shared';

const CardFiles = observer((props) => {
  const list = props.list || [];

  return (
    <ul className="mx-24px">
      {
        list.map((item, index) => {
          const id = item.file_id || item.id || `file_${index}`;
          const name = item.file_name || item.title || "";
          const abstract_info = item.summary || item.content || "";

          const ext = HelperCore.getFileNameExt(name);

          return (
            <li className="px-10px hover:bg-[#f7f7f7] rounded-8px" key={id}>
              <div className="block text-14px leading-20px !text-black hover:text-black py-16px">
                <div className="flex flex-row items-center mb-8px h-20px">
                  <div className="size-16px rounded-full mr-6px overflow-hidden">
                    <img className='size-full' src={ALL_FILE_ICONS[ext] || 'https://p3.ssl.qhimg.com/t110b9a9301e7123672fdc63a36.png'} />
                  </div>
                  <div className='text-14px leading-20px w-0 flex-grow truncate'>{name}</div>
                </div>
                <p className="line-clamp-2 text-12px leading-20px text-black text-opacity-50 mb-0">
                  {abstract_info || ''}
                </p>
              </div>
              <div className="h-1px bg-black bg-opacity-9"></div>
            </li>
          )
        })
      }
    </ul>
  )
});

export default CardFiles;